import { type CutoffTime, type Day, DAYS } from '@choco-admin/types';
import { DateTime } from 'luxon';

export const DEFAULT_CUTOFF_TIME = '10:00';

// Map numeric days to Day type (0 = Sunday, 1 = Monday, etc.)
export const numericDayToDay: Record<number, Day> = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

// Map Day type to numeric day (Sunday = 0, Monday = 1, etc.)
export const dayToNumeric: Record<Day, number> = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const DEFAULT_FORM_VALUES = {
  allowCustomProducts: false,
  mandatoryCustomerNumber: false,
  mandatoryDeliveryDate: true,
  enableProductComments: false,
  allowFractionalUnits: false,
  allowOnlyOneVariant: false,
  sortBy: 'orderGuide' as const,
  cutoffType: 'strict' as const,
  deliveryDays: [] as Day[],
  cutoffTimes: DAYS.reduce(
    (acc, day) => {
      acc[day] = DEFAULT_CUTOFF_TIME;
      return acc;
    },
    {} as Record<Day, CutoffTime>
  ),
};

export const formatTimeForDisplay = (time24: string): string => {
  if (!time24) return '';
  const [hours, minutes] = time24.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const generateTimeOptions = () => {
  const slots = [];
  for (let i = 0; i < 24 * 60; i += 30) {
    const hour = Math.floor(i / 60);
    const minute = i % 60;
    slots.push({
      value: `${String(hour).padStart(2, '0')}:${String(minute).padStart(
        2,
        '0'
      )}`,
      label: DateTime.local()
        .set({ hour, minute })
        .toLocaleString(DateTime.TIME_SIMPLE),
    });
  }
  slots.push({ value: '23:59', label: 'End of day' });
  return slots;
};

export const DAY_MAP: Record<string, Day> = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
};
